// extracted by mini-css-extract-plugin
module.exports = {"loader":"Loader_loader__19nGp","loader_loading":"Loader_loader_loading__2MPdR"};